// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HG30","footer":"styles_footer__UwQwZ"};